export default "__VITE_ASSET__Bn8JBlvU__"